<nz-modal [nzMaskClosable]='false'
          [nzWidth]='720'
          [nzVisible]='showModal'
          [nzTitle]="'流程信息'"
          [nzFooter]='modalFooter'
          (nzOnCancel)='handleCloseModal()'>
  <nz-table #basicTable [nzData]='tableData'
            [nzPageSize]='999'
            [nzHideOnSinglePage]='true'
            [nzScroll]="{y: '350px'}"
  >
    <thead>
    <tr>
      <th nzWidth='180'>处理时间</th>
      <th nzWidth='100'>处理人</th>
      <th nzWidth='100'>处理步骤</th>
      <th nzWidth='100'>处理动作</th>
      <th nzWidth='240'>处理意见</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor='let item of basicTable.data'>
      <td>{{item.finishAt | date:"yyyy-MM-dd HH:mm:ss"}}</td>
      <td>{{item.ownerAccount}}</td>
      <td>{{item.nodeName}}</td>
      <td>{{item.selAction}}</td>
      <td>{{item.comments}}</td>
    </tr>
    </tbody>
  </nz-table>
  <ng-template #modalFooter>
    <button nz-button nzType='primary' (click)='handleCloseModal()'>
      确定
    </button>
  </ng-template>
</nz-modal>
